<template>
  <div>
    <base-header class="pb-6" style="background-color: #248dc1 !important;">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Reportes de Siniestros</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          
        </div>
      </div>
      
    </base-header>

    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card" >
            <form class="needs-validation" id="formSearch"
                @submit.prevent="sendForm">
              <div class="form-row">
                  <div class="col-md-6" > 
                      <base-input label="Compañía:" v-model="inputs.compañia"
                                  :error="getError('compañia')"
                                  v-validate="'required'"
                                  name="compañia"
                      >
                          <el-select  v-model="inputs.compañia"
                                      placeholder="Seleccione una compañia..."
                          >
                              <el-option ref="selectCompañia" v-for="option in selectCompañias"
                                          :key="option.label"
                                          :label="option.label"
                                          :value="option.value">
                              </el-option>
                          </el-select>
                      </base-input>
                  </div>
                  <div class="col-md-6">
                      <base-input label="Rango de fechas:" v-model="inputs.rango"
                                  :error="getError('rango de fechas')"
                                  v-validate="'required'"
                                  name="rango de fechas"
                      >
                          <flat-picker slot-scope="{focus, blur}"
                                      @on-open="focus"
                                      @on-close="blur"
                                      :config="configRango"
                                      class="form-control datepicker"
                                      v-model="inputs.rango">
                          </flat-picker>
                      </base-input>
                  </div>
              </div>
              <div class="form-row">
                <div class="col-md-6" > 
                    <base-input label="Sponsor:" v-model="inputs.sponsor"
                                
                                name="sponsor"
                    >
                        <el-select  v-model="inputs.sponsor"
                                    placeholder="Seleccione un sponsor..."
                        >
                            <el-option ref="selectSponsor" v-for="option in selectSponsors"
                                        :key="option.label"
                                        :label="option.label"
                                        :value="option.value">
                            </el-option>
                        </el-select>
                    </base-input>
                </div>
              </div>
            </form>
            <div class="form-row">
                <base-button type="success" nativeType="submit" form="formSearch" icon><i class="fa fa-file" aria-hidden="true"></i> Exportar Excel</base-button>
            </div>
        </card>
      </div>
    </div>
    
    <div class="container" >

    </div>
    
  </div>
</template>
<script>
  // Components
  import BaseProgress from '@/components/BaseProgress';
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';

  import { Select, Option } from 'element-ui';
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  const Spanish = require("flatpickr/dist/l10n/es.js").default.es;
  

  export default {
    components: {
      BaseProgress,
      RouteBreadCrumb,
      StatsCard,
      [Select.name]: Select,
      [Option.name]: Option,
      flatPicker,
    },
    data() {
        return {
            
            selectCompañias: [],
            selectSponsors: [],
            dates: {
                range: undefined
            },
            configRango: {
                locale: Spanish,
                allowInput: false, 
                mode: 'range', 
                dateFormat: 'd-m-Y'
            },
            inputs: {
                compañia: undefined,
                rango: '',
                sponsor: undefined
            },
            data: {},
            
            
        };
    },
    methods: {
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      fetchData()
      {
          var vm = this;
          this.axios({
              url: 'api/reportes/companies_list',
              method: 'GET',
          }).then( response => {
              vm.selectCompañias = response.data;
          }).catch( error => {
              console.log(error);
          });
          this.axios({
              url: 'api/reportes/sponsors_list',
              method: 'GET',
          }).then( response => {
              vm.selectSponsors = response.data;
          }).catch( error => {
              console.log(error);
          });
      },
      sendForm()
      {
            var vm = this;
            this.firstFormSubmit().then( response => {
                console.log('retorno promesa de validacion', response);
                if( response ){
                    if( vm.inputs.rango.split(" a ").length == 2 ){
                        this.axios({
                            url: 'api/reportes/siniestros_query',
                            method: 'POST',
                            data: {
                                company: vm.inputs.compañia,
                                range: vm.inputs.rango.split(" a "),
                                sponsor: vm.inputs.sponsor
                            },
                            responseType: 'blob', // important
                            headers: { 'Accept': 'application/vnd.ms-excel' },
                        }).then( response => {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'file.xlsx');
                            document.body.appendChild(link);
                            link.click();
                        }).catch( error => {
                            if( error.response.status == 422){
                                Object.entries(error.response.data.errors).forEach( elem => {
                                    vm.$notify({
                                        message: elem[1][0],
                                        timeout: 5000,
                                        icon: 'ni ni-bell-55',
                                        type: 'danger'
                                    });
                                });
                            }else{
                                console.log(error);
                                vm.$notify({
                                    message: 'Hubo un error, no se pudo realizar la consulta',
                                    timeout: 5000,
                                    icon: 'ni ni-bell-55',
                                    type: 'default'
                                });
                            }
                        });
                    } else {
                        vm.$notify({
                            message: 'Formato de rango de fechas incorrecto',
                            timeout: 5000,
                            icon: 'ni ni-bell-55',
                            type: 'default'
                        });
                    }

                        
                }
            });
      },
    },
    mounted() {
      this.fetchData();
    },
  };
</script>
<style></style>
